import { useParams } from "react-router-dom";

export default function CategoryPage() {
  const { item } = useParams();

  return (
    <div style={{ padding: "50px" }}>
      <h1>{item.replace(/-/g, " ")}</h1>
      <p>This is the category page for: {item}</p>
    </div>
  );
}
